<template>
  <div>
  <div class="section">
    <div class="row">
      <div class="col-12 pb-1 pt-2 border-bottom">
        <h5 class="h5-sor">账户信息 <small class="text-muted">(以下均在客户端中输入，详见教程)</small></h5>
      </div>
    </div>
    <dl class="account-info row mt-3 pb-3 border-bottom">
      <dt class="col-12 row">
        <p class="sTitle">接入地址：</p>
        <div class="d-inline-block value">
          <span class="d-inline-block" style="min-width: 140px">{{ common.linkStr }}</span>
          <a @click.stop="ctrlC(common.linkStr)"
             class="btn btn-success btn-sm copy">复制地址</a>
        </div>
      </dt>
      <dt class="col-12 row">
        <p class="sTitle">接入账号：</p>
        <div class="d-inline-block value">
          <span class="d-inline-block" style="min-width: 140px">{{ accessUser }}</span>
          <a v-if="userData.role == 1" @click="$router.push({name:'withDrawal'})"
             class="btn btn-success btn-sm">申请提现</a>
        </div>
      </dt>
      <dt class="col-12 row">
        <p class="sTitle">连接密码：</p>
        <div class="d-inline-block value">
          <span class="d-inline-block" style="min-width: 140px">{{ accessPass }}</span>
          <a @click="$router.push({name:'editPass',params:userData})"
             class="btn btn-success btn-sm">修改密码</a>
        </div>
      </dt>
      <dt class="col-12 row">
        <p class="sTitle">账户时长：</p>
        <div class="d-inline-block value">
          {{ getLabelByValue(editionOptions,edition) }} 可用{{ useTime+1<0 ? 0 : useTime+1 }}天 – 续费最高获赠100天
        </div>
      </dt>
      <dt class="col-12 row">
        <p class="sTitle">在线数量：</p>
        <div class="d-inline-block value"><span class="d-inline-block" style="min-width: 140px">{{ linkNum }}</span><a
            @click="closeLink" class="btn btn-success btn-sm">强制下线</a></div>
      </dt>
    </dl>
  </div>
  <div id="renew" class="row btn-sor mt-2 mb-5">
    <div class="col-6">
      <a @click="$router.push({name:'money'})" class="btn btn-primary btn-block">
        账户续费 <br><small>(
        最高可获赠100天会员)</small>
      </a>
    </div>
    <div class="col-6 pl-0">
      <button @click="toVerifyEmail" id="buy_new" class="btn btn-primary btn-block">
        免费体验<br><small>(
        验证邮箱，领取120分钟)</small>
      </button>
    </div>
    <div class="col-12 mt-2">
      <a @click="$router.push({name:'shareLink'})" class="btn btn-primary btn-block p-2">
        长期免费使用{{this.common.name}} <br><small>(
        分享好友，可抢先体验4KVR超高速升级)</small>
      </a>
    </div>
    <div id="a_tips" class="col-12 mt-3 mt-md-1 mx-auto text-center">
      <a @click="$router.push({name:'product'})" class="col-auto col-md-auto text-decoration-none px-0 text-primary">
        <small>如何使用</small>
      </a> <small>|</small>
      <a @click="$router.push({name:'superPenetration'})" class="col-auto col-md-auto text-decoration-none px-0 text-primary">
        <small>超级穿透</small>
      </a>
<!--      <small>|</small>-->
<!--      <a @click="$router.push({name:'product'})" class="col-auto col-md-auto text-decoration-none px-0 text-primary">-->
<!--        <small>限量路由器</small>-->
<!--      </a>-->
    </div>
  </div>
  <div class="section">
    <div class="row">
      <div class="col-12 pb-1 pt-2 border-bottom">
        <h5 class="h5-sor">一键链接 <small class="text-muted">(一键呼起手机中客户端并自动连接)</small></h5>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-6">
        <a :href="linkStrApple" class="btn btn-block d-flex justify-content-center btn-success btn-sm" style="padding: 10px 0 10px 0">
          <div class="flex-column align-self-center text-left pl-2">
            苹果系统一键连接                        </div>
        </a>
      </div>
      <div class="col-6 pl-0">
        <a
            :href="'anyconnect://connect?name='+this.accessUser+'&amp;host='+this.common.linkStr+'&amp;prefill_username='+this.accessUser+'&amp;prefill_password='+this.accessPass"
            class="btn btn-block d-flex justify-content-center btn-success btn-sm" style="padding: 10px 0 10px 0">
          <div class="flex-column align-self-center text-left pl-2">
            安卓系统 一键连接                        </div>
        </a>
      </div>
      <p class="text-primary text-center w-100 mb-0 pt-3">
        <a @click="$router.push({name:'tutorials'})">
          <small>一键连接失败? 请进入教程页面，按提示重新设置</small>
        </a>
      </p>
    </div>
<!--    <div class="row mt-2 mb-5">-->
<!--      <div class="col-4 pl-1 pr-1">-->
<!--        <a @click="$router.push({name:'shareLink'})" class="w-100">-->
<!--          <img src="../../assets/user/user1.png" class="img-fluid w-100 rounded" alt="banner">-->
<!--        </a>-->
<!--      </div>-->
<!--      <div class="col-4 pl-1 pr-1">-->
<!--        <a @click="$router.push({name:'product'})" class="w-100">-->
<!--          <img src="../../assets/user/user2.png" class="img-fluid w-100 rounded" alt="banner">-->
<!--        </a>-->
<!--      </div>-->
<!--      <div class="col-4 pl-1 pr-1">-->
<!--        <a @click="$router.push({name:'money'})" class="w-100">-->
<!--          <img src="../../assets/user/user3.png" class="img-fluid w-100 rounded" alt="banner">-->
<!--        </a>-->
<!--      </div>-->
<!--    </div>-->
  </div>
    <downLoadApp></downLoadApp>
  <div class="section">
    <div class="row">
      <div class="col-12 pb-1 pt-2 border-bottom">
        <h5 class="h5-sor">使用教程</h5>
      </div>
    </div>
    <div class="row">
      <div class="btn-group w-100" role="group" aria-label="Basic example">
        <a v-for="item in list" :key="item.name" @click="goTutorials(item.name)" class="btn btn-light">
          <i class="fa fa-2x" :class="item.icon"></i><br>{{ item.name }}
        </a>
      </div>
    </div>
  </div>
  <div class="row">
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
  </div>
    <footerPage></footerPage>
  </div>
</template>

<script>
import downLoadApp from "@/components/userInfo/downLoadApp";
import footerPage from "@/components/userInfo/footer";
import { getToken,getUser} from "../../axios/token";
import qs from "qs";

export default {
  name: "homePage",
  components: {downLoadApp, footerPage},
  data() {
    return {
      list: [
        {icon: 'fa-apple', name: 'IOS'},
        {icon: 'fa-android', name: 'Android'},
        {icon: 'fa-windows', name: 'Windows'},
        {icon: 'fa-apple', name: 'Mac Os'},
      ],
      //版本类型
      editionOptions: [
        {label: '个人/企业版', value: 1},
        {label: '4K视频不限速版', value: 2},
        {label: 'Pro专业版', value: 3}
      ],
      accessUser: '',
      accessPass: '',
      edition: 1,
      type: 1,
      useTime: 0,
      linkNum: 0,
      userData: {},
    }
  },
  methods: {
    ctrlC(str){
      this.$copyText(str)
      this.$message({
        message:'复制成功',
        type:"success"
      })
    },
    goTutorials(name) {
      this.$router.push({
        name: 'tutorials',
        params: {
          name: name
        }
      })
    },
    getLabelByValue(arr, value) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].value === value) {
          return arr[i].label;
        }
      }

      return null; // 如果未找到对应的label，则返回null或其他适合的默认值
    },
    async toVerifyEmail(){
      let data = {
        id:this.userData.id+'',
        url: this.common.homeLink+'callbackAddress'
      }
      await this.axios.post('/user/getVerifyEmail',qs.stringify(data)).then((res)=>{
        if(res.data.code===0){
          this.$message({
            message:'邮件已发送，请前往确认',
            type:'success'
          });
        }else if(res.data.code ===2){
          this.$message({
            message:"您已验证过邮箱，请勿重复验证",
            type:'error'
          });
        }
      });

    },
    closeLink(){
      let data = {
        token:getToken()
      };
      this.axios.post('/user/close',qs.stringify(data), {
        headers: {
          "Jwt": getToken()
        }
      }).then(()=>{
        this.$message({
          message:'已登出所有账户',
          type:'success'
        });
      });

    },
    getLinkNum(){
      let data = {
        username:getUser()
      };
      this.axios.post('/user/getLinkNum',qs.stringify(data), {
        headers: {
          "Jwt": getToken()
        }
      }).then(res=>{
        this.linkNum = res.data.data
      });
    }
  },
  computed: {
    linkStrApple() {
      return `anyconnect://connect?name=${this.accessUser}&host=${this.common.linkStr}&prefill_username=${this.accessUser}&prefill_password=${this.accessPass}`
    },
  },
  async mounted() {
    let data = {
      username:getUser()
    };
    this.getLinkNum();
    await this.axios.post('/user/detail',qs.stringify(data), {
      headers:{
        "Jwt":getToken()
      }
    }).then(res=>{
      this.userData = res.data.data;
      this.accessUser = this.userData.username;
      this.accessPass = this.userData.pin_code;
      this.edition = this.userData.edition;
      let dateString = this.userData.limittime; // 请替换为您的日期字符串

      let timestamp = new Date(dateString).getTime();
      let today = new Date(); // 获取当前日期
      this.useTime = Math.floor((timestamp - today) / (1000 * 60 * 60 * 24));
    });
    this.axios.post('/user/getLinkNum',qs.stringify(data), {
      headers: {
        "Jwt": getToken()
      }
    }).then(res=>{
      this.linkNum = res.data.data
    });
  }
}
</script>

<style scoped>
.container-md{
  padding: 0!important;
}
.section{
  padding: 15px;
}
@media (min-width: 768px) {
  .h5-sor {
    font-size: 2rem;
  }
}

@media (min-width: 437px) and (max-width: 767px) {
  .container-md {
    max-width: 960px;
  }

  .sTitle {
    font-size: 16px;
  }

  .sTitle ~ div {
    font-size: 16px;
  }

  .h5-sor {
    font-size: 1.5rem;
  }
}

@media (max-width: 436px) {
  .sTitle {
    font-size: 12px;
  }

  .sTitle ~ div {
    font-size: 12px;
  }

  .h5-sor {
    font-size: 1.1rem;
  }
}

html {
  height: 100%;
}

body {
  position: relative;
  min-height: 100%;
  box-sizing: border-box;
  padding-bottom: 125px; /* .footer 的高度，为 footer 占位 */
}

footer {
  width: 100%;
  height: 125px;
}

.btn-sor .btn {
  background-color: #03a7ef;
  padding-top: 2px;
  padding-bottom: 2px;
}

.account-info .value {
  font-weight: 500;
  color: #23238E;
}

.account-info dt {
  line-height: 35px;
  height: 35px;
}

.help-config-btn {
  border: 3px dashed #797979;
  background-color: #F2F2F2;
  color: #797979 !important;
}

.help-config-btn > .small-icon {
  border: 2px dashed #797979;
  background-color: #D7D7D7;
  color: #797979 !important;
  padding: 3px 5px;
  border-radius: 5px;
}

#download-groups a {
  min-height: 80px;
}
</style>